import NewRelicUtils from 'config/monitoring/NewRelicUtils'

import InterWebviewBridge, {
  interWbSession,
  IWbTac,
  IWbTic,
  WbEnvironments,
} from '@interco/inter-webview-bridge'

class BridgeService {
  private static interWb = InterWebviewBridge.getInstance()

  static isBrowser(): boolean {
    return this.interWb.getEnvironment() === WbEnvironments.BROWSER
  }

  static async ticWb(ticProps: IWbTic): Promise<void> {
    try {
      if (!this.isBrowser()) {
        await interWbSession.tic(ticProps)
      }
    } catch (error) {
      NewRelicUtils.noticeError(error as Error)
      throw error
    }
  }

  static async tacWb(tacProps: IWbTac): Promise<void> {
    if (!this.isBrowser()) {
      await interWbSession.tac(tacProps)
    }
  }
}

export default BridgeService
